import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';
import { CheckIcon } from 'src/assets/dynamicSvg';

const Pill = styled.div<{ $bordered?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 52px;
  padding: 8px 16px 8px 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  ${({ theme, $bordered }) => $bordered && `border: 1px solid ${theme.colors.stroke};`}
`;

export const AcceptedPill: React.FC<{ bordered?: boolean }> = ({ bordered }) => (
  <Pill $bordered={bordered}>
    <CheckIcon color="statusGreen" style={{ width: 20, height: 20 }} />
    <Poppins px={14} weight={600} color="statusGreen" css="text-transform: uppercase;">
      Accepted
    </Poppins>
  </Pill>
);
